<template>
  <div class="comment-actions">
    <ActionsMenu
      :actions="actions"
      :options="{
        theme: 'light tooltip-standard-size'
      }"
      @toggle-visibility="$emit('toggle-visibility')"
      @toggle-important="$emit('toggle-important')"
      @edit-comment="$emit('edit-comment')"
      @delete-comment="$emit('delete-comment')"
    />
  </div>
</template>

<script>
import ActionsMenu from "@/components/ActionsMenu.vue";

export default {
  components: {
    ActionsMenu
  },
  props: {
    comment: {
      type: Object,
      default: null
    }
  },
  emits: [
    "edit-comment",
    "toggle-important",
    "delete-comment",
    "toggle-visibility"
  ],
  computed: {
    actions() {
      return [
        {
          label: this.comment.customer_visible
            ? "Visible to Customer"
            : "Mark Visible to Customer",
          icon: this.comment.customer_visible
            ? "fa-regular fa-eye"
            : "fa-regular fa-eye-slash",
          eventName: "toggle-visibility",
          className: "menu-item",
          visible: this.comment.customer_visible_editable
        },
        {
          label: this.comment.pinned ? "Unpin" : "Pin",
          icon: "fa-regular fa-exclamation-circle",
          className: "menu-item",
          eventName: "toggle-important"
        },
        {
          label: "Edit",
          icon: "fa-regular fa-edit",
          eventName: "edit-comment",
          className: "menu-item",
          visible: this.comment.editable
        },
        {
          label: "Delete",
          icon: "fa-regular fa-trash-alt",
          eventName: "delete-comment",
          className: "menu-item",
          visible: this.comment.editable
        }
      ];
    },
    visibleActions() {
      return this.actions.filter(
        (action) => !Object.keys(action).includes("visible") || action.visible
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.comment-actions > div {
  display: flex;
  align-items: flex-start;
}
</style>
